import React from 'react';
import { ArrowDownIcon, ArrowRightIcon, CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCta } from '../SectionCta';
import { afterItems, beforeItems } from '../../data/content';
import { images } from '../../data/offer';
export function BeforeAfter() {
  return <section aria-labelledby="before-after" className="bg-white px-4 py-16 sm:py-24" data-id="element-65" data-mp="22m2ddegjhtwj">
      <div className="mx-auto max-w-6xl" data-id="element-66" data-mp="2z9z0z3ae9ph9">
        <div id="before-after" data-id="element-67" data-mp="2z8xkgjam0as5">
          <SectionHeading title={<>
                From memorizing disconnected ABG values… <span className="text-navy-700" data-id="element-69" data-mp="2q9kcxw61pwa2">to studying with a structured roadmap</span>
              </>} subtitle="You don’t need more disconnected notes. You need a clearer way to organize what you’re learning." data-id="element-68" data-mp="2ubfcow8bw1lq" />
        </div>

        <div className="mt-12 grid items-stretch gap-4 lg:grid-cols-[1fr_auto_1fr] lg:gap-6" data-id="element-70" data-mp="1esu3m46bsoc8">
          <div className="rounded-3xl bg-alert/[0.06] p-6 ring-1 ring-alert/25 sm:p-8" data-id="element-71" data-mp="19ygbqbqvgzcb">
            <div className="flex items-center gap-3" data-id="element-72" data-mp="1739m6q62h40m">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-alert text-white" data-id="element-73" data-mp="1c3e66q66ogvl">
                <XIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-74" data-mp="y3wbxva4cbeu" />
              </span>
              <div data-id="element-75" data-mp="132fz1z0g7t8s">
                <p className="text-xs font-extrabold uppercase tracking-wider text-alert" data-id="element-76" data-mp="131xw6jja6grw">Before</p>
                <h3 className="font-display text-xl font-black text-ink" data-id="element-77" data-mp="odjvof9c74ei">Without the roadmap</h3>
              </div>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-78" data-mp="fe6gd5yj7llv">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink/80" data-id="element-79" data-mp="jfrralri9ptf">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-80" data-mp="jdfaibxhhlhy" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex items-center justify-center" aria-hidden="true" data-id="element-81" data-mp="agxyl6hapjl5">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy-900 text-cta" data-id="element-82" data-mp="2c5keyp5dcdbl">
              <ArrowDownIcon className="h-6 w-6 lg:hidden" data-id="element-83" data-mp="27bg6u2kd9z8x" />
              <ArrowRightIcon className="hidden h-6 w-6 lg:block" data-id="element-84" data-mp="23cqtub38qjpt" />
            </span>
          </div>

          <div className="rounded-3xl bg-ok/[0.07] p-6 ring-2 ring-ok/40 sm:p-8" data-id="element-85" data-mp="1ye5qi2sozjx5">
            <div className="flex items-center gap-3" data-id="element-86" data-mp="2v3epx8q24ywm">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-ok text-white" data-id="element-87" data-mp="2v0skpfqn2vhk">
                <CheckIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-88" data-mp="2m2gnguv9ozg5" />
              </span>
              <div data-id="element-89" data-mp="2h3cea48cf1pt">
                <p className="text-xs font-extrabold uppercase tracking-wider text-ok" data-id="element-90" data-mp="2h3voszvnyntt">After</p>
                <h3 className="font-display text-xl font-black text-ink" data-id="element-91" data-mp="1antdidilawzp">With the ABG Clinical Roadmap™</h3>
              </div>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-92" data-mp="15mvu5xlufwwm">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] font-medium leading-snug text-ink" data-id="element-93" data-mp="vltjslcbr54h">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-94" data-mp="10jv04yid8qc9" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <figure className="mx-auto mt-12 flex max-w-2xl items-center gap-4" data-id="element-95" data-mp="1ab97fsgk6ufy">
          <img src={images.rachel} alt="" className="h-14 w-14 shrink-0 rounded-full object-cover object-top" data-id="element-96" data-mp="1ea89946zub36" />
          <blockquote className="text-lg font-semibold italic leading-snug text-ink" data-id="element-97" data-mp="1j8015y7n1x7d">
            “My goal is to help you spend less time searching for information and more time studying it in a structured way.”
            <figcaption className="mt-1 text-sm font-medium not-italic text-ink/60" data-id="element-98" data-mp="1t5xwt6rtuwa0">— Rachel Bennett</figcaption>
          </blockquote>
        </figure>

        <SectionCta label="I want a more structured approach to ABG interpretation" data-id="element-99" data-mp="3v0f2ej81xhrz" />
      </div>
    </section>;
}